// 最高学历学校所在地枚举
// 编码与 mytgo / egoadmin / tgo.admin / xcx_tgo 保持严格一致
export default [
  { id: 1, name: '海外' },
  { id: 2, name: '国内-大陆' },
  { id: 3, name: '国内-港澳台' }
]
